<template>
<v-container>

  <v-alert v-model="alert" type="warning">
    Cet office n'existe pas
  </v-alert>
<v-card v-if="!alert">
<v-card-title  class="text-left"
><v-skeleton-loader
  v-if="office == null"
      text-left
      type="chip"
      min-width="400"
    ></v-skeleton-loader>
  <span v-else> <h3 class="title">{{ office.name.fr }}</h3></span></v-card-title>
    <v-divider/>
    <v-card-text>
      <v-subheader class="subtitle-2">Adresse</v-subheader>
      <p> {{ office.address }}</p>

<p>Vous êtes le propriétaire de cet établissement ? <a href="mailto:contact@go-france.net">Contactez-nous</a> afin de pouvoir le modifier.</p>
    </v-card-text>
<v-divider/>
    <v-card-actions>
      <v-btn target="_blank" v-if="office.geolocation" text color="teal darken-2" :href="'https://maps.google.com/maps?q=loc:'+office.geolocation.lat+','+office.geolocation.lng"  >{{ $t("detail.goTo") }}</v-btn>
      <v-btn :to="{name:'PointsOffice', params:{'slug': this.slug}}" dark text color="teal darken-2">Voir ses points touristiques</v-btn>
    </v-card-actions>
</v-card>
</v-container>
</template>
<script>

import firebase from '@firebase/app';

export default {
  props: ['slug'],
  data: () => ({
    office: null,
    data: null,
    alert: false,
    firestore: null
  }),
  mounted() {
    this.firestore = firebase.firestore();
    const self = this;
    this.geocollection = this.firestore.collection('tourist_office');
      this.geocollection.doc(this.slug).get().then((snapshot) => {
        if (snapshot.exists) {
          self.office = snapshot.data();
        } else {
          self.alert = true;
        }
      }).catch(() => {
        self.alert = true;
      })
  }
}
</script>
